import { render, staticRenderFns } from "./micoapp_home.vue?vue&type=template&id=27bb0078&scoped=true"
import script from "./micoapp_home.vue?vue&type=script&lang=js"
export * from "./micoapp_home.vue?vue&type=script&lang=js"
import style0 from "./micoapp_home.vue?vue&type=style&index=0&id=27bb0078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb0078",
  null
  
)

export default component.exports